import React, { useState } from "react";
import UnitPrice from "./Main";

const DEFAULT_VALUE = {
  value: null,
  warning: null,
  message: 'Testing'
}

const Demo = () => {
  const [value, setValue] = useState({...DEFAULT_VALUE})

  return (
    <>
      <UnitPrice
        default_value={'100.25'}
        value={value}
        // show_message={true}
        onChange={(val) => setValue(val)}
      />
      <br/>
      <br/>
      {value && <ul>
        <li>Value: {value.value}</li>
      </ul>}
    </>
  )
}

export default Demo;
